/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    export class FormtagsGrid extends NoboxEntityGrid<FormtagsRow, any> {
        protected getColumnsKey() { return FormtagsColumns.columnsKey; }
        protected getDialogType() { return FormtagsDialog; }
        protected getIdProperty() { return FormtagsRow.idProperty; }
        protected getInsertPermission() { return FormtagsRow.insertPermission; }
        protected getLocalTextPrefix() { return FormtagsRow.localTextPrefix; }
        protected getService() { return FormtagsService.baseUrl; }


        //protected getButtons() {
        //    var $this = this;
        //    var buttons = super.getButtons();
        //    buttons.splice(0, 1);
        //    return buttons;
        //}
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            return true;
        }
    }
}